import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";


export default function VtigerSolutions() {
  useEffect(() => {
    document.title = "Managed Vtiger Solutions to Optimize Your Business Operation";
        sal();
      }, []);
  return (
    <>
      <Helmet>
        <title>Managed Vtiger Solutions to Optimize Your Business Operation</title>
        <meta name="description" content="Get the best Managed vtiger solutions to streamline workflows, enhance customer management, and ensure smooth CRM operations for your growing business today." />
        <meta name="keywords" content="Managed Vtiger Solutions" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/vtiger-solutions`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/vtiger-solutions`} />
        <meta property="og:title" content="Prime CRM and Workflow Fusion with Advance Vtiger Solutions" />
        <meta property="og:description" content="Enhance your business processes with uninterrupted Vtiger solutions. Rationalize workflows, boost collaboration, and manage data with our customized solutions" />
       </Helmet>
        <section className="banner-bg bg-dark linux-reseller-banner">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">CRM That Works The Way You Do.</span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Too Much on Your Plate? Our Vtiger Solutions Manage All.</h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Ever think that your tasks are really winning and you’re only running behind? Our Vtiger solutions flip the whole script. All your customers, tasks, and team updates-finally under one roof. No more chasing, no more mess.</p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate open-live-chat btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <span className="btn-arrow__text">
                                Talk to an Expert
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                    </div>
                    <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                    <img alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" src="/images/vtiger-sol-banner.webp" />
                    </div>
                </div>
            </div>
        </section>

      <section className="pt-100 pb-100">
        <div className="container">
            <div className="feature-1-wrapper px-10 py-14 bg-white rounded-3 position-relative z-2">
                <img src="images/feature-shape.png" alt="image" className="img-fluid position-absolute start-0 top-0 z-n1" />
                <div className="row justify-content-center">
                    <div className="col-xxl-6 col-xl-8">
                        <div className="text-center mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <h2 className="mb-3">Failed Orders? It’s Time to Meet Vtiger CRM!</h2>
                        </div>
                    </div>
                </div>
                <div className="row g-lg-4 justify-content-center pt-6">
                    <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Get CRM Vtiger 20x Quicker, All Thanks to SSD</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">SSL Certificate Without Spending a Penny</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Skilled Vtiger Experts to Accelerate Your CRM</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <ul className="list-unstyled d-flex flex-column gap-3 mb-0">
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">Level Up Your Website with CloudFlare CDN</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">PHP7 + Nginx + Varnish + MariaDB</p>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <div className="w-4 h-4 bg-success flex-shrink-0 rounded-circle fs-10 lh-1 text-white d-flex align-items-center justify-content-center">
                                    <i className="fa-solid fa-check"></i>
                                </div>
                                <p className="fw-bold mb-0">With CSF Firewall, Protect Your Site</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
      </section>
    
      <div className="pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                  <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Solutions Just For You</small>
                    <h2 className="mb-4">Work Smarter: Customer Service Made Easy with Vtiger Solutions </h2>
                  </div>
                  <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                        <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/hackers-not-with-us.webp" /></div>
                        <h6 className="mb-4">Hackers? Not With Us.</h6>
                        <p className="mb-0">Patching, firewalls, malware security, and SSL certificates always keep your business safe at every step.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/hosting-crm-easy.webp" /></div>
                        <h6 className="mb-4">Hosting & CRM? Easy.</h6>
                        <p className="mb-0">We offer support for Vtiger CRM and hosting, ensuring professional guidance for any problem.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/data-everything-good.webp" /></div>
                        <h6 className="mb-4">Data? Everything Good.</h6>
                        <p className="mb-0">We take everyday snapshots & always store 30 days of backups, managing all with Vtiger solutions.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/live-are-you-sure.webp" /></div>
                        <h6 className="mb-4">24/7 Live. Are You Sure?</h6>
                        <p className="mb-0">With enterprise-level Vtiger solutions, infrastructure, and multi-level redundancy, we offer 99.9% uptime.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/vtiger-doesnt-slow.webp" /></div>
                        <h6 className="mb-4">Vtiger That Doesn’t Slow</h6>
                        <p className="mb-0">Backed by NVMe, HTTP/2, PHP7, and a free CDN, our Vtiger Hosting is engineered to offer high speed.</p>
                    </div>
                  </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                  <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                        <div className="mb-8"><img alt="image" className="img-fluid" src="/images/crm-vtiger-no-panic.webp" /></div>
                        <h6 className="mb-4">CRM Vtiger, No Panic </h6>
                        <p className="mb-0">Shifting your whole CRM Vtiger setup? We manage all the migrations just for you-fast and completely safe.</p>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>

      <section className="pb-100">
        <div className="container">
            <div className="bg-white px-8 py-10 rounded-3">
                <div className="row align-items-center g-4">
                    <div className="col-lg-5">
                        <img src="/images/vtiger-crm-turn-a-lead.webp" alt="image" className="img-fluid sal-animate" data-sal="fade" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                    </div>
                    <div className="col-lg-7">
                        <div className="d-inline-flex align-items-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                              <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Lead to Loyalty
                            </small>
                        </div>
                        <h2 className="mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">A Lead To a Long-Term Relationship</h2>
                        <p className="mb-0 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Still running emails & spreadsheets? Vtiger CRM is always there for you to keep your sales, support, and marketing equal, so you usually close deals faster and develop stronger customer connections.</p>
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium btn-height rounded sal-animate mt-5" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                              <span className="btn-arrow__text">
                                  Free Trial
                                  <span className="btn-arrow__icon">
                                      <i className="fa-solid fa-arrow-right"></i>
                                  </span>
                              </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <div className="pb-100">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/deploy-vtiger-in-a-second.webp" alt="image" className="img-fluid" />
                    </div>
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Turn Customer Data Into Action.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Deploy Vtiger in a Second
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Set up the whole Vtiger CRM in just a click with 400+ applications. Backups and cloning-done smoothly.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Solutions That Actually Fit.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Inbox, Which is Spam-FREE
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Stay secure with Vtiger hosting and enterprise-level spam and virus filtering-spam-free inbox, no hassle.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/spam-free-inbox.webp" alt="image" className="img-fluid" />
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section>
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xxl-7 col-xl-8">
                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Your Sales & Support-Aligned.
                        </small>
                    </div>
                    <div className="text-center mb-8">
                        <h2 className="text-dark mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Here’s What You Win with Every Single Account…</h2>
                    </div>
                </div>
            </div>
            <div className="row g-4">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 p-xl-10 rounded-3 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Help Is Next Door</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">01</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/next-door-help.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Get 24/7 Vtiger CRM support with the help of a chat or call, plus full access to practical articles and blogs.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Hosting That’s Quick</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">02</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/quick-hosting.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Level up your reseller hosting servers with caching and advanced performance-optimizing technology.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Track, Manage, Done</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">03</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/track-manage-done.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Our user-friendly admin panels make management of Vtiger solutions and server performance smooth.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Sky’s Not the Limit</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">04</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/sky-not-limit.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Get unlimited databases, sites, emails, and FTP accounts with Vtiger CRM, scalable to meet your demands.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Your Team, In Sync</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">05</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/your-team-in-sync.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">With Vtiger solutions, share full access with anyone to manage support, billing, and console tasks smoothly.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="bg-white p-6 rounded-3 p-xl-10 h-100">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-4">
                            <h6 className="text-dark mb-0">Safety on Autopilot</h6>
                            <p className="h5 mb-0 text-dark text-opacity-25">06</p>
                        </div>
                        <div className="d-flex gap-6 flex-wrap flex-sm-nowrap">
                            <div className="flex-shrink-0">
                                <img src="/images/safety-on-autopilot.webp" alt="icon" className="img-fluid"/>
                            </div>
                            <div>
                                <p className="mb-0">Always stay safe with managed security, automatic backups, and monitoring for your Vtiger solutions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="simple-box-section pt-100 pb-100">
        <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="card rounded-3 cta-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <div className="card-body px-6 pt-60 pb-60">
                          <div className="row justify-content-center">
                              <div className="col-md-11 col-lg-8 col-xl-8">
                                  <div className="text-center">
                                    <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Smarter CRM Starts With Vtiger.</span>
                                      <h4 className="mb-4">
                                          The Vtiger CRM Solution That Does Everything…!!!
                                      </h4>
                                      <p className="mb-6">
                                        Vtiger CRM hosting always puts marketing, sales, and 24/7 support all in a single place-so you can focus more on scaling, not managing. 
                                      </p>
                                      <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              +91-7737300013
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                      <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                          <span className="d-inline-block me-1 flex-shrink-0">
                                              <i className="las la-comments"></i>
                                          </span>
                                          <span className="btn-arrow__text">
                                              Talk to an Expert
                                              <span className="btn-arrow__icon">
                                                  <i className="fa-solid fa-arrow-right"></i>
                                              </span>
                                          </span>
                                      </Link>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </section>
      
    </>
  );
}

